import { ROUTE_BASE } from '#/config/routes';

export function normalizeAsidePath(path) {
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
}

/** 主控台 ROUTE_BASE 僅精確匹配；其餘允許子路徑前綴。 */
export function isAsidePathMatch(pathname, to) {
  const current = normalizeAsidePath(pathname);
  const target = normalizeAsidePath(to);

  if (target === ROUTE_BASE) {
    return current === ROUTE_BASE;
  }

  return current === target || current.startsWith(`${target}/`);
}

/** 同層子選單取最長路徑匹配，避免 material-mgmt 與 template 等同時 active。 */
export function resolveActiveAsideChild(pathname, children = []) {
  const enabledChildren = children.filter((child) => child.enabled !== false);
  let bestMatch = null;
  let bestLength = -1;

  enabledChildren.forEach((child) => {
    const prefixes = [child.to, ...(child.matchPrefixes ?? [])];
    const matchedPrefix = prefixes.find((prefix) => isAsidePathMatch(pathname, prefix));
    if (!matchedPrefix) {
      return;
    }

    if (matchedPrefix.length > bestLength) {
      bestMatch = child.to;
      bestLength = matchedPrefix.length;
    }
  });

  return bestMatch;
}

export function isAsideChildActive(pathname, childTo, siblings = []) {
  return resolveActiveAsideChild(pathname, siblings) === childTo;
}

export function resolveExpandedAsideParentIndex(pathname, menuList = []) {
  const activeParentIndex = menuList.findIndex(
    (item) => item.children && resolveActiveAsideChild(pathname, item.children) !== null,
  );

  return activeParentIndex >= 0 ? activeParentIndex : null;
}
